import * as angular from 'angular';

import { ComponentDefinition, KeyValuePair } from '../../models';

class MultiSelectController implements angular.IComponentController {
    model: any;
    onClick?: (value: any) => void;
    onSelect?: () => void;
    options: KeyValuePair<any, string>[];
    placeholder: string;

    static $inject = [];

    click($item: KeyValuePair<any, string>) {
        if (this.onClick) {
            this.onClick({ item: $item.value });
        }
    }

    select($item: KeyValuePair<any, string>, $value) {
        if (this.onSelect) {
            this.onSelect();
        }
    }
}

export const wtMultiSelect: ComponentDefinition = {
    componentId: 'wtMultiSelect',
    controller: MultiSelectController,
    template: require('./multiSelect.component.html'),
    controllerAs: 'vm',
    bindings: {
        model: '=', // Must be equel to work
        placeholder: '<',
        options: '<',
        onClick: '&?',
        onSelect: '&?'
    }
};
